import { render } from "./trainSearch.vue?vue&type=template&id=96a6b60e&scoped=true"
import script from "./trainSearch.vue?vue&type=script&lang=js"
export * from "./trainSearch.vue?vue&type=script&lang=js"

import "./trainSearch.vue?vue&type=style&index=0&id=96a6b60e&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96a6b60e"]])

export default __exports__